import randomID from '__jsLibs/randomID';
import VueToastr from 'vue-toastr';
import PortalVue from 'portal-vue';
import vueStore from '__jsStore';
import VueMask from 'v-mask';

let vueCropper = require('vue-cropper');
Vue.use(VueToastr, {
	defaultStyle:       {
		'background-color': 'white',
		'color':            'black',
		'opacity':          1,
		'padding':          '20px',
		'right':            '18px',
		'top':              '27px'
	},
	defaultProgressBar: false,
	defaultTimeout:     3000,
});
Vue.use(VueMask);
Vue.use(PortalVue);
Vue.use(vueCropper.default);

export default (array) => {
	if (array && array.length) {
		window.VueInstances = {};
		window.VuexModules = {};

		Vue.use(Vuex);

		const store = new Vuex.Store(vueStore);

		array.map(component => {
			Vue.component(component.name, component.component);
			window.VueInstances[component.name] = {};
		});

		const components = document.querySelectorAll('[data-is]');
		// шукаєм всі шаблони глобальних компонентів та запускаєм їх
		for (let i = 0; i < components.length; i++) {
			const componentName = components[i].getAttribute('data-is');
			let componentParams = components[i].getAttribute('data-params');

			// перевіряєм, чи включений компонент в процес збірки проекту
			if (window.VueInstances[componentName]) {
				if (componentParams) {
					componentParams = componentParams.replace(/'/g, '"');
					componentParams = JSON.parse(componentParams);

					// хак, який дозволяє обійти валідатор w3c
					components[i].setAttribute('is', componentName);

					/**
					якщо темплейт глобального компонента не вказаний, то генерується рандомна назва
					це дозволяє запобігти перезаписуванню неназваних компонентів

					також для компонентів, в яких вказаний темплейт, до назви додається сіль
					це дозволяє багаторазово використовувати компоненти із однаковими назвами темплейтів
					*/
					const templateName = () => {
						if (componentParams.template) {
							return `${componentParams.template}_${randomID(4)}`;
						}
						return randomID(10);
					};

					window.VueInstances[componentName][templateName()] = new Vue({
						el:     components[i],
						store
					});
				}
				else {
					throw new Error(['dataParams is undefined', components[i]]);
				}
			}
			else {
				throw new Error(`Component ${components[i].getAttribute('data-is')} is not enabled, but used! Check module constructor options.`);
			}
		}
	}
};
